import CheckBoxCardNew from '../CheckBoxCardNew/CheckBoxCardNew';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import styles from './CheckBoxCardGroup.module.scss';
import type { CheckBoxCardGroupProps } from './interfaces';

const CheckBoxCardGroup = ({
  options,
  onChange,
  errorMessage,
}: CheckBoxCardGroupProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.base}>
        {options.map(({ label, checked, name }) => {
          return (
            <CheckBoxCardNew
              key={name}
              name={name}
              errorMessage={errorMessage}
              onChange={onChange}
              checked={checked}
            >
              {label}
            </CheckBoxCardNew>
          );
        })}
      </div>
      {errorMessage && (
        <ErrorMessage hasRelativePosition>{errorMessage}</ErrorMessage>
      )}
    </div>
  );
};

export default CheckBoxCardGroup;
